export const getUniqueCurrencies = (currencies = []) => {
  if (!Array.isArray(currencies)) {
    return [];
  }

  return currencies.filter((currency, index, items) => {
    const normalizedTitle = String(currency?.title || "")
      .trim()
      .toLowerCase();

    return (
      items.findIndex(
        (item) =>
          String(item?.title || "").trim().toLowerCase() === normalizedTitle
      ) === index
    );
  });
};
